<template>
  <div>
    <my-navbar :controller="controller" />

    <div class="header bg-gradient-dark pb-8 pt-5 pt-md-8">
      <div class="container-fluid">
        <div class="header-body">
          <div class="row">
            <!-- CONTENIDO HEADER -->
            <div class="col-lg-7 col-md-10">
              <h1 class="display-3 text-white">Migración a CP</h1>
              <p class="text-white mt-0 mb-5">Para comenzar, busca un cliente en el listado</p>
              <div>
              <ul class="nav">
                <li class="nav-item">
                  <a @click="multiple = true" class="nav-link btn mr-2" :class="multiple ? 'btn-primary text-white': 'btn-white'" href="javascript:void(0);">Múltiple</a>
                </li>
                <li class="nav-item">
                  <a @click="multiple = false" class="nav-link btn " :class="!multiple ? 'btn-primary text-white': 'btn-white'" href="javascript:void(0);">Simple</a>
                </li>
              </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- CONTENT -->
    <div class="container-fluid mt--7">
            <div class="row justify-content-center" >
              <div class="col-xl-4">
                <SearchDealer :inputData.sync="filters.dealers" :options="{ active: true }" />
              </div>
              <div class="col-xl-8">
                <template v-if="!multiple">
                  <div class="card card-client shadow" v-if="dealer.identifier">
                    <div  class="card-body">
                      <div class="selected">
                        <div class="row">
                          <div class="col">
                            <p class="dealer-name">{{dealer.fantasy_name}}</p>
                            <p class="dealer-id">Código: {{dealer.id}}</p>
                          </div>
                        </div>

                        <SwitchElement 
                          :isCP="true"
                          :switchValue.sync="isMigrated"
                          :control.sync="control"
                          :isDisabled="disableUpdate"
                          :dealerIdentifier="dealer.identifier"
                          :serviceIdentifier="service.cp"
                          title="¿Migrar este dealer?"/>
                      </div>

                      <div class="small text-muted" v-if="disableUpdate">
                        <i class="fa fa-info-circle mx-2 text-info text-right"></i> Esta acción no se puede revertir.</div>

                      <div class="p-2">
                        <hr class="my-4">
                        
                        <SwitchElement 
                          :isDisabled="!isAuthorized"
                          :switchValue.sync="newCars"
                          :dealerIdentifier="dealer.identifier"
                          :serviceIdentifier="service.newCars"
                          title="Vehículos nuevos"/>
                        
                        <div class="small text-muted mb-2">Últ. Modif.: {{newCars.modifiedUtc | formatDateTime}}</div>
                        
                        <SwitchElement 
                          :isDisabled="!isAuthorized"
                          :switchValue.sync="usedCars"
                          :dealerIdentifier="dealer.identifier"
                          :serviceIdentifier="service.usedCars"
                          title="Vehículos usados"/>

                        <div class="small text-muted">Últ. Modif.: {{usedCars.modifiedUtc | formatDateTime}}</div>

                        <div v-if="hasLocalData" class="p-3 text-center mt-3">
                          <p class="font-weight-bold m-0 mb-1 text-info">Proceso de migración a Control Panel</p>
                          <p class="m-0 mb-1 small">Actualizado por: <strong>{{control.user}}</strong> </p>
                          <p class="m-0 mb-1 text-muted small">Fecha Inicio: {{control.startDate | formatDateTime}}</p> 
                          <p v-if="control.endDate" class="m-0 mb-1 text-muted small">Fecha Finalización: {{control.endDate | formatDateTime}}</p>
                          <div class="alert p-2 mt-2" :class="getStatus(control.status).alert" style="max-width: 150px; margin: 0 auto;">
                            {{getStatus(control.status).label}}
                          </div> 
                        </div>

                        <div v-if="!isAuthorized" class="alert p-2 mt-4">
                            <i class="fas fa-warning text-danger mr-2"></i> No estás autorizado para modificar esta información
                        </div>

                      </div>
                    </div>
                  </div>
                </template>

                <MultipleMigration v-if="multiple"
                :dealer.sync="dealer"
                :loadingServices="loadingServices"
                :disableUpdate="disableUpdate"
                :hasLocalData="hasLocalData"
                :control="control"
                :status="getStatus(control.status)"/>

              </div>
            </div>

    </div>
  </div>
</template>
<script>
import { Dealer, Control } from "./model";
import utils from "@/helpers/utils";
import Auth from "@/helpers/middleware";
import sysMsg from "@/helpers/system.message";
import dealerServices from "@/services/dealers.services";
import migrationServices from "@/services/migration.services";
import SwitchElement from '@/components/Switch'
import MultipleMigration from './Multiple'
export default {
  name: "CPMigrations",
  components: { SwitchElement, MultipleMigration },
  data() {
    return {
      controller: {
        title: "Operaciones",
        mainRouter: "/operaciones/cp-migraciones"
      },
      loadingServices: false,
      multiple: true,
      service: {
        cp: "38668026-3425-45ce-9de2-2b3007cd1779",
        newCars: "15c6b078-d1d9-4c97-a311-ffb863d3a08c",
        usedCars: "a3517ac1-5b44-4d5f-ae49-a953ea2f39d2"
      },
      isMigrated: {},
      newCars: {},
      usedCars: {},
      dealer: new Dealer(),
      actions: Auth.getActions(this.$route.name),
      control: new Control(),
      selectedDealers:[],
      filters: {
        dealers: null,
        loading: false,
        search: null,
        selected: {
          dealer: new Dealer(),
          details: {},
        },
      }
    };
  },
  computed: {
    isAuthorized() {
      return this.actions.post || this.actions.put
    },
    disableUpdate() {
      return this.isMigrated && this.isMigrated.createdUtc || !this.isAuthorized
    },
    hasLocalData() {
      return this.control.sellerIdentifier && this.isMigrated && this.isMigrated.createdUtc
    }
  },
  watch: {
    multiple: {
      deep: true,
      handler(data) {
        if(data != null && this.dealer.identifier) {
          this.getServices(this.dealer.identifier);
        }
      }
    },
    "filters.dealers": {
      deep: true,
      handler(data) {
        this.dealer = new Dealer();
        this.isMigrated = {}
        this.newCars = {}
        this.usedCars = {}
        this.control = new Control(),
        this.filters.search = null;
        if (data != null) {
          this.getDealerById(data.cod_cliente);
        }
      }
    }
  },
  filters: {
    formatDateTime(str) {
      return str ? utils.formatDateTime(str) : 'N/A';
    }
  },
  methods: {
    addDealer() {
      if(!this.selectedDealers.find(item => item.identifier === this.dealer.identifier)) {
        this.selectedDealers.push(this.dealer);
      }
      console.log(this.selectedDealers);
    },
    removeDealer(index) {
      this.selectedDealers.splice(index, 1);
    },
    getDealerById(dealerId) {
      dealerServices.general.getDealer(dealerId).then(res => {
        this.dealer = res.data;
        this.getServices(res.data.identifier);
        this.getLocalDealer(res.data.identifier);
      }).catch(error => sysMsg.getResponseMessage(error.response));
    },
    getLocalDealer(dealerIdentifier) {
      migrationServices.localApi.getDealerService(dealerIdentifier).then(data => {
        this.control = {...data, sellerIdentifier: data.sellerIdentifier};
      }).catch(error => {
        if(error.response && error.response.status === 404) {
          return false
        };
        sysMsg.getResponseMessage(error.response)
      });
    },
    getServices(dealerIdentifier) {
      this.loadingServices = true;
      migrationServices.cpApi.getDealerServices(dealerIdentifier).then(data => {
        this.checkServiceStatus(data);
        this.loadingServices = false;
      }).catch(error => {
        this.loadingServices = false;
        sysMsg.getResponseMessage(error.response)
      });
    },
    checkServiceStatus(data) {
      if(data && data.length > 0) {
        this.isMigrated = this.filterData(data, this.service.cp);
        this.newCars = this.filterData(data, this.service.newCars);
        this.usedCars = this.filterData(data, this.service.usedCars);
      }
    },
    filterData(data, identifier) {
      const service = data.find(item => (item.identifier ? item.identifier.toString().toLowerCase() : null) === identifier && item.status === 'active');
      return service ? service : { status: false, identifier }
    },
    getStatus(str) {
      str = str ? str.toUpperCase() : null;

      switch (str) {
        case "COMPLETED":
          return { label: 'COMPLETADO', alert: 'alert-success'}
          break;
        case "PROCESSING":
          return { label: 'EN PROCESO', alert: 'alert-info'}
          break;
        case "ERROR":
          return { label: 'ERROR', alert: 'alert-danger'}
          break;
        default:
          return { label: 'DESCONOCIDO', alert: 'alert-light'}
          break;
      }
    }
  }
};
</script>
<style lang="scss">
.selected {
    padding: 10px;

  .action {
    display: flex;
    justify-content: space-around;
    align-items: flex-start;
  }

  .dealer {
    &-name {
      font-size: 16px;
      font-weight: 600;
      margin: 0;
    }

    &-id {
      font-size: 14px;
      opacity: .5;
      margin: 0 0 10px;
    }
  }
}
</style>